import React from 'react';

import maisner from '../../imgs/maisner.png';

export default class Train3 extends React.Component {
  render() {
    return (
      <div className='typography-container'>
        <p>
    <h1>Эффект Мейснера</h1>
        </p>
<p>
    Одно из свойств, присущих всем сверхпроводникам, носит название эффекта
    Мейснера. Если поместить магнит над сверхпроводником, магнит зависнет в
    воздухе, как будто поддерживаемый некой невидимой силой. Причина эффекта
    Мейснера заключается в том, что магнит обладает свойством создавать внутри
    сверхпроводника собственное «зеркальное отражение», так что настоящий
    магнит и его отражение начинают отталкиваться друг от друга. Еще одно
    наглядное объяснение этого эффекта — в том, что сверхпроводник непроницаем
    для магнитного поля. Он как бы выталкивает магнитное поле. Поэтому, если
    поместить магнит над сверхпроводником, силовые линии магнита при контакте
    со сверхпроводником исказятся. Эти силовые линии и будут выталкивать магнит
    вверх, заставляя его левитировать.
</p>
<p>
    Если человечество получит возможность использовать эффект Мейснера, то
    можно вообразить шоссе будущего с покрытием из такой специальной керамики.
    Тогда при помощи магнитов, размещенных у нас на поясе или на днище
    автомобиля, мы сможем волшебным образом парить над дорогой и нестись к
    месту назначения без всякого трения или потерь энергии.
</p>
    <img src={maisner} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/docs/Train-3.js